<template>
    <div
     id="nav-scroller"
      ref="editingpanel"
      class="editing-container"
      v-bind:class="{'readOnly':readOnly, 'windowContainer':!pageMode}"
      style="position:relative; outline: none; white-space: pre-wrap; overflow-wrap: break-word; -webkit-user-modify: read-write-plaintext-only;"
      :contenteditable="'false'"
     
    >
  
    <div
        v-for="(phrase, index) in phrases"
        :key="phrase.id"
        class="scroller"
      >
      <phrase
          :id="phrase.id"
          :active="true"
          :phraseIndex="index"
          :phrase="phrase"
          :speakers="speakers"
          :duration="duration"
          :readOnly="true"
          :isConfidence="false"
          :showModifiedTooltip="showModifiedTooltip"
          @phrase-clicked="onPhraseClicked"
          @set-time="(sec, target, noScroll, noAutoPaginate, autoPlay) => $emit('set-time',sec, target, noScroll, noAutoPaginate, autoPlay)"
          @play-media="() => $emit('play-media')"
          @pause-media="() => $emit('pause-media')"
        >
        </phrase>

  </div>

   <!-- <DynamicScroller
      id="vue-recycle-scroller"
      class="scroller"
      v-bind:class="{'windowMode':!pageMode}"
      key-field="id"
      :items="phrases"    
      :buffer="300"
      :min-item-size="54"
      :page-mode="pageMode"
      :detectHover="false"
      @sort="onVirtualScrollerSorted"
      style="z-index:22"
    >
  
      <template v-slot="{ item, index, active }" >
        <DynamicScrollerItem
          :item="item"
          :active="active"
          :size-dependencies="[ item.transcript ]"
          :data-index="index"
        >
        <phrase
          v-if="active"
          :id="active && !readOnly?item.id:null"
          :active="active"
          :phraseIndex="index"
          :phrase="item"
          :speakers="speakers"
          :duration="duration"
          :readOnly="readOnly"
          :isConfidence="isConfidence"
          :showModifiedTooltip="showModifiedTooltip"
          @phrase-clicked="onPhraseClicked"
          @save-speaker="onSpeakerSave"
          @set-time="(sec, target, noScroll, noAutoPaginate, autoPlay) => $emit('set-time',sec, target, noScroll, noAutoPaginate, autoPlay)"
          @play-media="() => $emit('play-media')"
          @pause-media="() => $emit('pause-media')"
          @update-speaker="onUpdateSpeaker"
          @open-notes="(phrase) => $emit('open-notes',phrase)"
          @test="onTest"
        >
        </phrase>
        </DynamicScrollerItem>
      </template>
    </DynamicScroller> -->
  <!-- <ReplacePopup ref="replacePopup" @close="dictionaryModal.active = false" @save-phrase="savePhrase" @add-history="(original)=>{addToHistoryStack(original)}" @add-future="(modified)=>{addToFutureStack(modified, true)}" :dictionaryModal="dictionaryModal" :selectionInfo="selectionInfo" :phrases="phrases" :language="language" :defaultLanguage="defaultLanguage" :category="category"></ReplacePopup> -->
      <v-tooltip bottom v-if="false">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            v-show="!isFullScreen"
            class="fullscreen settings-control-button"
            @keydown.stop.prevent=""
            @mouseup.stop.prevent=""
            @click.stop.prevent="onToggleScreen(true)"
          >
            <v-icon>fullscreen</v-icon>
          </v-btn>
        </template>
        <span>{{ $lang.share.full_screen }}</span>
      </v-tooltip>
  
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            v-show="isFullScreen"
            class="fullscreen_exit settings-control-button"
            @keydown.stop.prevent=""
            @mouseup.stop.prevent=""
            @click.stop.prevent="onToggleScreen(false)"
          >
            <v-icon>fullscreen_exit</v-icon>
          </v-btn>
        </template>
        <span>{{ $lang.share.full_screen_exit }}</span>
      </v-tooltip>
    </div>
  </template>
  
  <script>
  import Phrase from "./Phrase";
 // import ReplacePopup from "./ReplacePopup";
 // import storeHelper from "@/utils/storeHelper";
//   import textHelper from "@/utils/textHelper";
//   import loggingHelper from '@/utils/loggingHelper';
  import transcriptHelper from "@/utils/transcriptHelper";
//   import { debounce } from "debounce";
  // @input="debounceOnInputChange($event)"
 // const storeModules = storeHelper.createHelpers(["editSession", "transcript"]);
  const moment = require("moment");
  export default {
    name: "editable-panel",
    props: ["globalPhrases","duration", "speakers", 'readOnly', 'language', 'defaultLanguage', 'pageMode', 'showModifiedTooltip', 'isExpanded', 'category'],
    components: {
      Phrase,
     // ReplacePopup
    },
    data() {
      return {
        phraseIndex: -1,
        currentWordIndex: -1,
        currentPhraseIndex: -1,
        wordHighlightingAnimation: null,
        selectionInfo: null,
        testContent: [],
        caretPosition: null,
        caretEndPosition:null,
        clickedPhraseId: null,
        isIMEInput: false,
        isFullScreen: false,
        mode: process.env.VUE_APP_MODE,
        modifiedPhrases:[],
        phrases:[],
        eventObj:null,
        historyStack:[],
        futureStack:[],
        logError:[],
        debounceOnInputChange: null,
        debounceCustomKeyPress: null,
       // debounceSetCaret: null,
        debouncePhraseCheck: null,
        scrollUIRendering:false,
        scrollUIRenderingTimeout:null,
        dictionaryModal:{
          active:false, 
          x:0,
          y:0, 
          selectionPhrase:'',
          selectionText:'',
          replaceText:'',
          selectionPhraseId: ''
        }
      };
    },
    computed: {
    //   ...storeModules.editSession.mapState({
    //     videoTime: state => state.media.currentTime,
    //     playing: state => state.media.playing,
    //     seekTime: state => state.media.seekTime,
    //     dictionary: state => state.settings.dictionary,
    //     isConfidence: state => state.isConfidence,
    //     videoCuts: state => state.videoCuts,
    //     paginated: state => state.settings.paginated,
    //     paginationPhrases: state => state.paginationPhrases,
    //     fastInputValues: state => state.settings.fastInputValues
    //   }),
  
      getContentEditableAvailableString(){
        const me = this;
        return me.$isBrowserSupported ? 'plaintext-only' : 'true'
      },
      transcriptId(){
        const me = this;
        return me.$route.params.id;
      }
    },
    // watch:{
    //   'dictionaryModal.replaceText': function (newVal, oldVal){
    //     const me = this;
    //        if(newVal){
    //          if(me.dictionaryModal.active){
    //             me.dictionaryModal.y = me.isExpanded ? (me.dictionaryModal.pageY - 370 - me.dictionaryModal.heightOffset) : (me.dictionaryModal.pageY - 203 - me.dictionaryModal.heightOffset);
    //          }
    //        }
    //        else{
    //          if(me.dictionaryModal.active){
    //             me.dictionaryModal.y = me.isExpanded ? (me.dictionaryModal.pageY - 345 - me.dictionaryModal.heightOffset) : (me.dictionaryModal.pageY - 178 - me.dictionaryModal.heightOffset);
    //          }
    //        }
    //    },
    //    isIMEInput: function(newVal){
    //     this.$emit('imei-update', newVal);
    //    }
    // },
    methods: {
    //   ...storeModules.transcript.mapActions(["updateSpeaker"]),
    //   ...storeModules.editSession.mapMutations(['dragTimeUpdate','resizeTimeUpdate']),
    //   ...storeModules.editSession.mapMutations(['setLocalPhrases','dragTimeUpdate','resizeTimeUpdate', 'setFocusId']),
    //   ...storeModules.editSession.mapActions(['removeVideoCuts','setVideoCuts']),
      onVirtualScrollerSorted(){
        const me = this;
        if(me.readOnly) return
  
        // if(me.debounceSetCaret){
        //   me.debounceSetCaret()
        // }
  
        if(me.debouncePhraseCheck) {
          me.debouncePhraseCheck()
        }
      },
      onTest(errMessage){
         const me = this
        // me.$forceUpdate();
        // console.log('test');
        // const id = errMessage.id;
  
        // const index = me.phrases.findIndex(function(p){return p.id === id})
        // if(index && index >-1){
        //   const clonePhrase = JSON.parse(JSON.stringify(me.phrases[index]))
        //   clonePhrase.words = null;
        //   me.savePhrase([clonePhrase], clonePhrase, 0,false, 'onInputChange');
        //   me.phrases.splice(index, 1)
          
        // }
  
  
        me.$emit('test', errMessage)
      },
    //   setCaret(){
    //     const me = this;
  
    //     if(me.readOnly) {
    //       return;
    //     }
  
    //     if(me.caretPosition >= 0 && me.clickedPhraseId && (me.caretPosition === me.caretEndPosition || isNaN(me.caretEndPosition))){
    //       let localCaretPosition = me.caretPosition;
    //       let localPhraseId = me.clickedPhraseId;
    //         transcriptHelper.setCaretByPhraseId(localPhraseId, localCaretPosition)
    //     }
    //     // select the text if previously was selected
    //     else if(me.caretPosition >= 0 && me.clickedPhraseId && (me.caretPosition !== me.caretEndPosition) && !isNaN(me.caretPosition) && !isNaN(me.caretEndPosition)){
    //       let localCaretPosition = me.caretPosition;
    //       let localPhraseId = me.clickedPhraseId;
    //       let targetElement = me.getElementByPhraseId(localPhraseId);
    //       if(targetElement){
    //         textHelper.selectTextByStartEnd(targetElement,localCaretPosition, me.caretEndPosition);
    //       }
          
    //     }
    //   },
      getElementByPhraseId(id){
        const idElement = document.querySelector('#'+id);
        return idElement ? idElement.querySelector(`div[contenteditable="plaintext-only"][data-container-position="${id}"]`) : null;
      },
      // updateCaretPosition(){
      //   const me = this;
      //   const selectionInfo = transcriptHelper.getSelectionInfo(me.phrases);
  
      //   if(selectionInfo && selectionInfo.charStartIndex > -1 && selectionInfo.phraseStartIndex > -1){
      //     me.caretPosition = selectionInfo.charStartIndex;
      //     me.caretEndPosition = selectionInfo.charEndIndex;
      //     me.clickedPhraseId = me.phrases[selectionInfo.phraseStartIndex].id;
      //     me.setFocusId(me.phrases[selectionInfo.phraseStartIndex].id);
      //   }
      // },
      clearCaretPosition(){
        const me = this;
        me.caretPosition = null;
        me.caretEndPosition = null;
        me.clickedPhraseId = null;
      },
      onPhraseClicked(){
        const me = this;
        let selectionInfo = transcriptHelper.getSelectionInfo(me.phrases);
  
        if(!selectionInfo){
          return;
        }
        let clonePhrase = me.phrases[selectionInfo.phraseStartIndex];
        let words = clonePhrase.words;
        let wordIndex = transcriptHelper.getWordIndexByIndex(
          words,
          selectionInfo.charStartIndex
        );
  
        me.clickedNode = transcriptHelper.getElement(selectionInfo.phraseStartIndex, wordIndex, me.phrases, me.readOnly)
       // me.checkEmptyPhrase(e)
        if (!me.clickedNode) {
          return;
        }
  
        // Set the player time when clicked on
        let startTime = me.clickedNode.getAttribute("data-start");
  
        // inline click to set media for mobile will cause issule for mobile
        if(!me.$isMobile){
          me.$emit('set-time', startTime,null, !me.readOnly);
        }
  
        // // Update the caret postion when clicked on phrase
        // me.updateCaretPosition();
       
        // Highlight the word when clicked on
        transcriptHelper.highlightWordByPosition(
          selectionInfo.phraseStartIndex,
          wordIndex,
          me.phrases
        );
      },
    //   onUpdateSpeaker(newSpeaker){
    //     const me = this;
    //      me.updateSpeaker({
    //       transcriptId: me.$route.params.id,
    //       newSpeaker: newSpeaker
    //     });
    //   },
    //   onInputChange(event) {
    //     const me = this;
    //     let logInfo = "";
  
    //     try{
    //       let selectionInfo = me.selectionInfo || transcriptHelper.getSelectionInfo(me.phrases); // me.selectionInfo || transcriptHelper.getSelectionInfo();
    //       me.selectionInfo = null;
  
    //       //console.log('input in')
    //       if (me.isInvalidSelectionInfoForInput(selectionInfo) ) {
    //         return;
    //       }
  
    //       if (!me.isIMEInput) {
    //         me.eventObj = event;
    //       //  me.selectionInfo = selectionInfo;
    //       //console.log('input change')
    //         let phraseIndex = selectionInfo.phraseStartIndex;
    //         let stringifyPhrase = JSON.stringify(me.phrases[phraseIndex]);
    //         let phrase = JSON.parse(stringifyPhrase);
    //         let diff = transcriptHelper.updateDifferenceToEntity(
    //           phrase,
    //           selectionInfo,
    //           event
    //         );
  
    //         if(!diff.dirty){
    //           return false;
    //         }
            
    //         // add to history
    //         me.addToHistoryStack([JSON.parse(stringifyPhrase)]);
    //         logInfo = diff.logInfo || "";
            
    //         if(logInfo){
    //           me.logError.push(logInfo);
    //         }
  
    //         while(me.logError.length > 10){
    //           me.logError.shift();
    //         }
  
    //         // Update the change in words
    //         phrase.words = diff.words;
  
    //         // remove empty span
    //         transcriptHelper.removeEmptyWords(phrase);
  
    //         // Update the current array entity object word
    //         phrase.transcript = transcriptHelper.toTranscript(phrase.words);
  
    //         if(me.dictionaryModal.active){
    //             me.dictionaryModal.replaceText = textHelper.getDifferenceText(me.dictionaryModal.selectionPhrase, phrase.transcript, selectionInfo.charStartIndex);
    //         }
  
    //         // Debounce save the phrase
    //         me.addToFutureStack([phrase], true);
  
    //         // charoffset is currently used only when imei input and compltet to have the updated caret pos
    //         me.savePhrase([phrase], phrase, selectionInfo.charStartIndex+ (selectionInfo.charOffSet || 0),false, 'onInputChange');
            
    //         return false;
    //       }
    //     }
    //     catch(exception){
    //       me.$emit("test", exception.message + '-' + exception.stack + 'logError:'+ JSON.stringify(me.logError));
    //     }
    //   },
    //   onSpeakerSave(phraseId, speaker) {
    //     const me = this;
    //     let phraseIndex =  me.phrases.findIndex(item => item.id === phraseId);
    //     let phrase = me.phrases.find(function(p) {
    //       return p.id === phraseId;
    //     });
  
  
    //     me.addToHistoryStack([JSON.parse(JSON.stringify(phrase))]);
        
    //     phrase.speaker = speaker;
        
    //     me.$set(me.phrases, phraseIndex, phrase);
    //     me.savePhrase([phrase], phrase, 0, true);
    //   },
      onToggleScreen(fullscreen) {
        const me = this;
        me.isFullScreen = fullscreen;
        me.$nextTick(() => {
          const sel = window.getSelection();
          sel.removeAllRanges();
        });
        me.$emit("toggleFullScreen", fullscreen);
      },
    //   savePhrase(modifiedPhrases, activePhrase, charIndex, forceRefresh, sourceType) {
    //     const me = this;
    //     const {indexes} = me.updateGlobalPhrases(modifiedPhrases)
    //   //  const indexes = [2];
    //     const updatedPhrases = me.phrases;
  
    //     sourceType = sourceType || 'customKeyPress';
    //     // test logging info
    //     const testLogging = {isIMEInput:me.isIMEInput}
  
    //     // // force caret update and then check the phrase and innertext
    //     me.$nextTick(() => {
    //         let selectionInfo = transcriptHelper.getSelectionInfo(me.phrases);
    //         // should manually set caret:
    //         // when multiple modifications (new line line merges, and multiple changes in different spot)
    //         // when imeiinput confirms by pressing enter
    //         // should not manully set caret:
    //         // when scroll (selecitoninfo will be null)
    //         // when clicked on else phrase (selection info will have a different phrase index)
    //         if((modifiedPhrases.length > 1 || (selectionInfo && me.phrases[selectionInfo.phraseStartIndex].id === activePhrase.id))){
    //           transcriptHelper.setCaretByPhraseId(activePhrase.id, charIndex);
    //         }
  
    //         const errMessage = loggingHelper.checkInputValid(me, updatedPhrases,modifiedPhrases,sourceType, me.eventObj,me.selectionInfo,testLogging);
    //         if(errMessage){
    //           me.$emit('test', {errorMessage:errMessage, forceRefresh:false});
    //         }
    //     })
  
    //     me.$forceNextTick(() => {
    //       me.updateCaretPosition();
    //       me.$emit('refresh', {
    //         modifiedPhrases,
    //         forceRefresh,
    //         activePhrase,
    //         charIndex,
    //         indexes,
    //         updatedPhrases,
    //         testLogging
    //       });
  
    //       //  const errMessage = loggingHelper.checkInputValid(me, updatedPhrases,modifiedPhrases,sourceType, me.eventObj,me.selectionInfo,testLogging);
    //       //   if(errMessage){
    //       //     me.$emit('test', {errorMessage:errMessage, forceRefresh:false});
    //       //   }
    //       // // this is to fix after compositioned on scroll
    //       // me.$nextTick(() => {
    //       //   me.updateCaretPosition();
    //       // })
  
    //     });
    //   },
    //   isInvalidSelectionInfoForInput(selectionInfo){
    //     return !selectionInfo || selectionInfo.charStartIndex < 0 || selectionInfo.charEndIndex < 0 || selectionInfo.phraseEndIndex < 0 || selectionInfo.phraseStartIndex < 0 || (selectionInfo.contentStart && selectionInfo.contentStart.contentEditable !== this.getContentEditableAvailableString);
    //   },
      isInvalidSelectionInfo(selectionInfo){
        const me = this;
        let isInvalid = !selectionInfo 
        || selectionInfo.charStartIndex < 0 
        || selectionInfo.charEndIndex < 0 
        || selectionInfo.phraseEndIndex < 0 
        || selectionInfo.phraseStartIndex < 0 
        || !me.phrases[selectionInfo.phraseEndIndex]
        || !me.phrases[selectionInfo.phraseStartIndex]
        || !me.phrases[selectionInfo.phraseEndIndex].words
        || !me.phrases[selectionInfo.phraseStartIndex].words
        // || !me.phrases[selectionInfo.phraseEndIndex].words[selectionInfo.charEndIndex]
        // || !me.phrases[selectionInfo.phraseStartIndex].words[selectionInfo.charStartIndex]
        || (selectionInfo.contentStart && selectionInfo.contentStart.contentEditable !== me.getContentEditableAvailableString) 
  
        if(!isInvalid){
          let wordIndexStart = transcriptHelper.getWordIndexByIndex(me.phrases[selectionInfo.phraseStartIndex].words, selectionInfo.charStartIndex)
          let wordIndexEnd = transcriptHelper.getWordIndexByIndex(me.phrases[selectionInfo.phraseEndIndex].words, selectionInfo.charEndIndex)
          isInvalid = wordIndexStart < 0 || wordIndexEnd < 0;
        }
  
        return isInvalid;
      },
      updateGlobalPhrases(modifiedPhrases){
        const me = this;
        const indexes = [];
  
        modifiedPhrases.forEach(function(newPhrase) {
         // let phrase = me.phrases.find(function(phase){return phase.id === newPhrase.id});
          let phraseIndex =  me.phrases.findIndex(item => item.id === newPhrase.id);
          let phrase = me.phrases[phraseIndex];
          if(phraseIndex >= 0){
          indexes.push(phraseIndex);
          }
          // if both is available update the content (phrase)
          if(phrase && newPhrase && newPhrase.words){
            const currentTime = moment.utc().format()
            phrase.modified = currentTime
            newPhrase.modified = currentTime
            phrase.modifiedBy = me.$lang.common.me
            newPhrase.modifiedBy = me.$lang.common.me
            me.$set(me.phrases, phraseIndex, JSON.parse(JSON.stringify(newPhrase)))
  
           // me.updatePaginatedPhrase(phrase.id, newPhrase);
          }
        });
        
  
        return {indexes:indexes};
      },
    //   addToHistoryStack(phrases){
    //       const me = this;
    //       me.historyStack.push(phrases);
    //       if(me.historyStack && me.historyStack.length > 20){
    //         me.historyStack.shift();
    //       }
    //   },
    //   addToFutureStack(phrases, overwrite){
    //       const me = this;
  
    //       if(overwrite){
            
    //         if(me.futureStack.length){
    //           const futurePhrase = me.futureStack.pop();
  
    //           // if future stack pop is equal to history pop then ignore
    //           if(futurePhrase.length && me.historyStack.length &&
    //           (futurePhrase[0].id === me.historyStack[me.historyStack.length -1][0].id && futurePhrase[0].transcript === me.historyStack[me.historyStack.length -1][0].transcript ||
    //           !futurePhrase[0].words && !me.historyStack[me.historyStack.length -1][0].words
    //           ) 
    //           &&
    //           (futurePhrase[futurePhrase.length-1].id === me.historyStack[me.historyStack.length -1][me.historyStack[me.historyStack.length -1].length -1].id && futurePhrase[futurePhrase.length-1].transcript === me.historyStack[me.historyStack.length -1][me.historyStack[me.historyStack.length -1].length -1].transcript ||
    //           !futurePhrase[futurePhrase.length-1].words && !me.historyStack[me.historyStack.length -1][me.historyStack[me.historyStack.length -1].length-1].words
    //           )
    //           ){
  
    //           }
    //           else{
    //             futurePhrase[0].type = 'future';
    //             me.historyStack.push(futurePhrase);
    //           }
    //         }
  
    //         me.futureStack = [];
    //       }
  
    //       me.futureStack.push(JSON.parse(JSON.stringify(phrases)));
    //       return true;
    //   },
      isPhrasesEqual(phrases1, phrases2){
        if(phrases1.length !== phrases2.length){
          return false;
        }
  
        for(var i = 0; i < phrases1.length; i++){
          if(phrases1[i].id !== phrases2[i].id || phrases1[i].transcript !== phrases2[i].transcript){
            return false;
          }
        }
  
        return true;
      },
      getNextInHistoryStack(){
          const me = this;
          let historyPhrases =  me.historyStack.pop();
  
          while(historyPhrases){
            const curPhrase = me.phrases.find(function(p){
              return p.id === historyPhrases[historyPhrases.length - 1].id;
            })
  
            const beginCurPhrase = me.phrases.find(function(p){
              return p.id === historyPhrases[0].id;
            })
            
            me.addToFutureStack(historyPhrases);
  
                if(historyPhrases[0].type !== 'future' && (!curPhrase || !beginCurPhrase && !me.historyStack.length
            || JSON.stringify(historyPhrases[historyPhrases.length - 1].words) !== JSON.stringify(curPhrase.words)
            || beginCurPhrase && JSON.stringify(historyPhrases[0].words) !== JSON.stringify(beginCurPhrase.words)
            )){
              delete historyPhrases[0].type;
              break;
            } 
  
            historyPhrases =  me.historyStack.pop();
          }
  
          return historyPhrases;
      },
      getNextInFutureStack(){
          const me = this;
          let futurePhrases =  me.futureStack.pop();
  
          while(futurePhrases){
            const curPhrase = me.phrases.find(function(p){
              return p.id === futurePhrases[futurePhrases.length-1].id;
            })
  
            const beginCurPhrase = me.phrases.find(function(p){
              return p.id === futurePhrases[0].id;
            })
            
            me.addToHistoryStack(futurePhrases);
  
                if(!curPhrase || !beginCurPhrase && !me.futureStack.length
             || JSON.stringify(futurePhrases[futurePhrases.length-1].words) !== JSON.stringify(curPhrase.words)
             || beginCurPhrase && JSON.stringify(futurePhrases[0].words) !== JSON.stringify(beginCurPhrase.words)){
              break;
            } 
  
            futurePhrases =  me.futureStack.pop();
          }
  
          return futurePhrases;
      },
    //   customKeypress(event) {
    //     const me = this; 
        
    //     me.eventObj = event;
  
    //     //  console.log('custom keypress in')
    //     // when typing in input
    //     if(event.target.tagName.toLowerCase() === 'input') {
    //       return;
    //     }
  
    //     // When multiple lines are selected and non char key was pressed
    //     let selectionInfo = transcriptHelper.getSelectionInfo(me.phrases);
  
    //     // when selected on wierd stuff
    //     if(me.isInvalidSelectionInfo(selectionInfo)) {
    //       event.preventDefault();
    //       return;
    //     }
        
    //     // first line first char press backspace, last line last char press delete
    //     if(selectionInfo.phraseStartIndex === 0 && selectionInfo.phraseEndIndex === 0 && selectionInfo.charStartIndex === 0 && selectionInfo.charEndIndex === 0 && textHelper.getEventType(event) === 'BACKSPACE')
    //     {
    //        event.preventDefault();
    //       return;
    //     }
  
  
    //     //  console.log('custom keypress change')
  
    //     event.preventDefault();
  
    //     // Check if the selection is full line
    //     selectionInfo.isFullLineSelection = selectionInfo.phraseStartIndex === selectionInfo.phraseEndIndex && me.phrases[selectionInfo.phraseStartIndex].transcript.length === (selectionInfo.charEndIndex - selectionInfo.charStartIndex)
    //     event.fastInputValues = me.fastInputValues;
    //     // check if current is deletion key
    //     if(textHelper.isDeletionKey(event) || event.type === "cut"){
    //       // When in first index of the row and backspace was hit should merge
    //       selectionInfo = transcriptHelper.getMergeOnBackSpaceSetup(
    //         event,
    //         me.phrases,
    //         selectionInfo
    //       );
  
    //       // When in last index of the previos row and delete was hit should merge
    //       selectionInfo = transcriptHelper.getMergeOnDeleteSetup(
    //         event,
    //         me.phrases,
    //         selectionInfo
    //       );
    //     }
  
    //     // me.selectionInfo = selectionInfo;
    //     let modifiedPhrases = [];
    //     me.caretPosition = selectionInfo.charStartIndex;
    //     me.caretEndPosition = selectionInfo.charEndIndex;
    //     const isMultiLineSelection = transcriptHelper.isMultilineSelection(selectionInfo);
    //     const isMultiCharSelection = transcriptHelper.isMultiCharSelection(selectionInfo);
  
    //     // When multiple paragraph is selected and char key or backspace or delete was pressed
    //     if (isMultiLineSelection && !textHelper.isEnterKey(event)) {
    //       const results= transcriptHelper.updateStorePhrasesMerge(
    //         event,
    //         me.phrases,
    //         selectionInfo
    //       );
  
    //       modifiedPhrases = results.modifiedPhrases;
  
    //       me.addToFutureStack(results.modifiedPhrases, true);
    //       me.addToHistoryStack(results.originalPhrases);
    //       me.savePhrase(
    //         modifiedPhrases,
    //         modifiedPhrases[0],
    //         selectionInfo.charStartIndex,
    //         true
    //       );
    //     }
    //      // multiple selction and delete, backspace or printable key is pressed.
    //      // exception for enter is when whole phrase is selected and enter is pressed
    //     else if (isMultiCharSelection && !textHelper.isEnterKey(event)) {
    //       me.replaceContentAndSave(selectionInfo,modifiedPhrases,event);
  
    //       // let phrase = me.phrases[selectionInfo.phraseStartIndex];
    //       // let originalPhrase = JSON.parse(JSON.stringify(me.phrases[selectionInfo.phraseStartIndex]));
    //       // let insertContent = textHelper.getEventValue(event, selectionInfo.isFullLineSelection);
    //       // me.addToHistoryStack([originalPhrase]);
  
    //       // transcriptHelper.mergeWord({
    //       //   phrase:phrase,
    //       //   index:selectionInfo.charStartIndex,
    //       //   newOffset:selectionInfo.charEndIndex - selectionInfo.charStartIndex,
    //       //  // isFullLineSelection:selectionInfo.isFullLineSelection,
    //       //  // event:event,
    //       //  inputData:insertContent
            
    //       // })
          
    //       // // remove empty span
    //       // transcriptHelper.removeEmptyWords(phrase.words);
    //       // modifiedPhrases.push(phrase);
  
    //       // me.addToFutureStack(modifiedPhrases, true);
    //       // me.savePhrase(modifiedPhrases, phrase, selectionInfo.charStartIndex + insertContent.length);
    //     }
    //     // when Enter is pressed
    //     else if (textHelper.isEnterKey(event)) {
    //       event.preventDefault();
    //       let enterResults = transcriptHelper.updateStorePhrasesSplit(
    //         me.phrases,
    //         selectionInfo
    //       );
    //       modifiedPhrases = enterResults.modifiedPhrases;
  
    //       me.addToHistoryStack(enterResults.originalPhrases);
    //       me.addToFutureStack(modifiedPhrases, true);
    //       me.savePhrase(modifiedPhrases, modifiedPhrases[0], 0, true);
    //     } // no selection and input
    //     else if (!isMultiLineSelection && !isMultiCharSelection && textHelper.isPrintableCharacters(event)) {
    //       event.preventDefault();
    //       me.insertContentAndSave(selectionInfo,modifiedPhrases,event)
    //     }
  
    //     // show the popup text
    //     if(!isMultiLineSelection && me.dictionaryModal.active && modifiedPhrases.length){
    //        // me.dictionaryModal.replaceText = textHelper.getDifferenceText(me.dictionaryModal.selectionPhrase, modifiedPhrases[0].transcript, selectionInfo.charStartIndex);
    //        me.setDictionaryPopupRepaceText(modifiedPhrases, selectionInfo);
    //     }
    //   },
    //   setDictionaryPopupRepaceText(modifiedPhrases,selectionInfo){
    //     const me = this;
    //     // if(me.isInvalidSelectionInfo(selectionInfo)){
    //     //   return;
    //     // }
    //     let phraseIndex = selectionInfo.phraseStartIndex;
    //     let phrase = me.phrases[phraseIndex];
  
    //     if(phrase){
    //       const originalPhrase = (modifiedPhrases && modifiedPhrases.length) ?modifiedPhrases[0].transcript : phrase.transcript;
    //       const replaceText = textHelper.getDifferenceText(me.dictionaryModal.selectionPhrase, originalPhrase, selectionInfo.charStartIndex);
    //       me.dictionaryModal.replaceText = replaceText;
    //     }
    //   },
    //   insertContentAndSave(selectionInfoObject,modifiedPhrases,event){
    //     const me = this;
    //     let selectionInfo = selectionInfoObject || transcriptHelper.getSelectionInfo(me.phrases);
  
    //     let phraseIndex = selectionInfo.phraseStartIndex;
    //       let phrase = me.phrases[phraseIndex];
    //       let wordIndex = transcriptHelper.getWordIndexByIndex(
    //         phrase.words,
    //         selectionInfo.charStartIndex
    //       );
          
    //     let insertContent = event.fastInputValues ? textHelper.getEventValue(event) : event;
    //       me.addToHistoryStack([JSON.parse(JSON.stringify(phrase))]);
  
    //       transcriptHelper.insertCharsInWord(
    //         phrase.words,
    //         wordIndex,
    //         selectionInfo.charStartIndex,
    //         insertContent
    //       );
  
    //       // Update the current array entity object word
    //       // remove empty span
    //       transcriptHelper.removeEmptyWords(phrase);
    //       phrase.transcript = transcriptHelper.toTranscript(phrase.words);
    //       modifiedPhrases.push(phrase);
  
    //       // Add to future steps
    //       me.addToFutureStack(modifiedPhrases, true);
  
    //       // Debounce save the phrase
    //       me.savePhrase(
    //         modifiedPhrases,
    //         phrase,
    //         selectionInfo.charStartIndex + insertContent.length
    //       );
    //   },
  
    //   replaceContentAndSave(selectionInfoObject,modifiedPhrases,event){
    //     const me = this;
    //     let selectionInfo = selectionInfoObject || transcriptHelper.getSelectionInfo(me.phrases);
        
    //     let phrase = me.phrases[selectionInfo.phraseStartIndex];
    //       let originalPhrase = JSON.parse(JSON.stringify(me.phrases[selectionInfo.phraseStartIndex]));
    //     let insertContent = event.fastInputValues ? textHelper.getEventValue(event) : event;
    //     //  let insertContent = textHelper.getEventValue(event, selectionInfo.isFullLineSelection);
    //       me.addToHistoryStack([originalPhrase]);
  
    //       transcriptHelper.mergeWord({
    //         phrase:phrase,
    //         index:selectionInfo.charStartIndex,
    //         newOffset:selectionInfo.charEndIndex - selectionInfo.charStartIndex,
    //        // isFullLineSelection:selectionInfo.isFullLineSelection,
    //        // event:event,
    //        inputData:insertContent
            
    //       })
          
    //       // remove empty span
    //       transcriptHelper.removeEmptyWords(phrase);
    //       modifiedPhrases.push(phrase);
  
    //       me.addToFutureStack(modifiedPhrases, true);
    //       me.savePhrase(modifiedPhrases, phrase, selectionInfo.charStartIndex + insertContent.length);
    //   },
      watchForGlobalPhrases(){
        const me = this;
        me.unwatchGlobalPhrases = me.$watch('globalPhrases', (newPhrases) => {
          if (newPhrases) {
            me.phrases = JSON.parse(JSON.stringify(newPhrases));
            me.historyStack = [];
            me.futureStack = [];
        //  me.setFocusId(me.phrases.length ? me.phrases[0].id : null);
            // Sets the global local store phrase 
              // if(!me.readOnly){
              //   me.setLocalPhrases(me.phrases);
              // }
            me.unwatchGlobalPhrases();
          }
        });
      },
    //   showPopupForCJK(selectionText){
    //     const me = this;
    //     const noSpace = process.env.VUE_APP_NO_SPACE.split(',');
    //     return selectionText && selectionText.trim().length > 0 && selectionText.trim().length < 30 && noSpace.indexOf(me.language) > -1
    //   },
    //   showPopupForNonCJK(selectionText){
    //     const me = this;
    //     const noSpace = process.env.VUE_APP_NO_SPACE.split(','); //selectionText.trim().length < 40 && 
    //     return selectionText && selectionText.trim().length > 1 && selectionText.split(' ').length < 10 && noSpace.indexOf(me.language) === -1
    //   },
    //   showReplacePopup(event){
    //       const me = this;
    //       const selection = window.getSelection();
    //       if(!selection.anchorNode || !selection.focusNode ||event.target.closest('.dictionary-popup')){
    //         return;
    //       }
          
    //       const selectionBox=window.getSelection().getRangeAt(0).getBoundingClientRect();
    //       const heightOffset = event.offsetY ;//% 27;
  
    //       // if(event.target.closest('.dictionary-popup')){
    //       //   return;
    //       // }
  
    //       me.$refs.replacePopup.onReset();
    //       me.dictionaryModal.heightOffset = heightOffset;
    //       me.dictionaryModal.pageY = event.pageY;
    //       me.dictionaryModal.replaceText = '';
    //       me.dictionaryModal.x = textHelper.selectionDirectionBackward() ? event.offsetX + (153) : event.offsetX + (153) - selectionBox.width;
    //       me.dictionaryModal.y = me.isExpanded ? (event.pageY - 345 - heightOffset) : (event.pageY - 178 - heightOffset);
  
    //       me.dictionaryModal.active = false;
  
    //       if(!me.dictionary){
    //         return;
    //       }
  
          
    //       if (window.getSelection && (window.getSelection()).modify) {
    //           const selectionInfo = transcriptHelper.getSelectionInfo(me.phrases);
    //           const showReplace = selectionInfo && !transcriptHelper.isMultilineSelection(selectionInfo);
  
    //           if(!showReplace || me.isInvalidSelectionInfo(selectionInfo)) return;
    //           const selectionText = textHelper.getSelectionText();
  
    //           if(me.showPopupForCJK(selectionText) || me.showPopupForNonCJK(selectionText)) {
    //             me.dictionaryModal.selectionText = selectionText.trim();
    //             me.dictionaryModal.selectionPhraseId = me.phrases[selectionInfo.phraseStartIndex].id;
    //             me.dictionaryModal.selectionPhrase = me.phrases[selectionInfo.phraseStartIndex].transcript.betterReplace(me.dictionaryModal.selectionText,'',selectionInfo.charStartIndex);
    //             me.$refs.replacePopup.selectionHasVideoCut(me.dictionaryModal.selectionPhraseId);
    //             setTimeout(function(){me.dictionaryModal.active = true},100);
    //           }
    //       }
  
    //       // me.$forceNextTick(function(){
    //       //   if (window.getSelection && (window.getSelection()).modify) {
    //       //     const selectionInfo = transcriptHelper.getSelectionInfo(me.phrases);
    //       //     const showReplace = selectionInfo && !transcriptHelper.isMultilineSelection(selectionInfo);
  
    //       //     if(!showReplace) return;
    //       //     const selectionText = textHelper.getSelectionText();
  
    //       //     if(me.showPopupForCJK(selectionText) || me.showPopupForNonCJK(selectionText)) {
    //       //       me.dictionaryModal.selectionText = selectionText.trim();
    //       //       me.dictionaryModal.selectionPhraseId = me.phrases[selectionInfo.phraseStartIndex].id;
    //       //       me.dictionaryModal.selectionPhrase = me.phrases[selectionInfo.phraseStartIndex].transcript.betterReplace(me.dictionaryModal.selectionText,'',selectionInfo.charStartIndex);
    //       //       me.$refs.replacePopup.selectionHasVideoCut(me.dictionaryModal.selectionPhraseId);
    //       //       setTimeout(function(){me.dictionaryModal.active = true},100);
    //       //     }
    //       // }
    //       // })
    //   },
    //   syncVideoCuts(noCutVideos, cutVideos){
    //     const me = this;
    //      // for all cut videos check if exist if not then add
    //       noCutVideos.forEach((startTime)=>{
    //         var exist = me.videoCuts.find(function(cut){return cut[0] === startTime});
  
    //         if(exist){
    //           me.removeVideoCuts({start:startTime, transcriptId:me.transcriptId});
    //         }
    //       })
  
    //       const ranges = [];
    //       if(cutVideos.length){
  
    //         let tempStart = cutVideos[0][0];
    //         let tempEnd = cutVideos[0][1];
    //         for(var i =1; i < cutVideos.length; i++){
  
    //           if(cutVideos[i][0] - cutVideos[i-1][1] < 0.1){
    //             tempEnd = cutVideos[i][1];
    //           }
    //           else{
    //             ranges.push([tempStart,tempEnd]);
    //             tempStart = cutVideos[i][0];
    //              tempEnd = cutVideos[i][1];
    //           }
  
    //           if(i === cutVideos.length -1){
    //             ranges.push([tempStart,tempEnd]);
    //           }
    //         }
    //       }
  
    //       ranges.forEach(function(range){
    //         me.setVideoCuts({range:range, transcriptId: me.transcriptId});
    //       })
    //   },
    //   updatePaginatedPhrase(updatePhraseId, newPhrase){
    //     const me = this;
    //     if(me.paginated){
    //             for(var i = 0 ; i <  me.paginationPhrases.length; i++){
    //               let index = me.paginationPhrases[i].findIndex(function(page){ return page.id === updatePhraseId});
    //               if(index > -1){
    //                 me.$set(me.paginationPhrases[i],index, newPhrase);
    //               // me.paginationPhrases[i][index] = modifiedPhrases[0];
    //                 break;
    //               }
    //             }
    //           }
    //   },
    //   undo(event){
    //     const me = this;
    //     const pre = me.getNextInHistoryStack();
    //       if(!pre) return;
    //       me.eventObj = event;
    //       me.$emit('save');
  
    //       const activePhrase = pre[pre.length-1];
    //       const clonePhrases = JSON.parse(JSON.stringify(me.phrases));
    //       const hash = {};
  
    //       const cutVideos = [];
    //       const noCutVideos = [];
    //       pre.forEach(function(prePhrase){
    //         hash[prePhrase.id] = prePhrase;
    //         if(prePhrase.words){
    //           prePhrase.words.forEach(function(word){
    //         // get all the starttime of cutvideos
    //               if(word.isVideoCut){
    //                 cutVideos.push([word.startTime,word.endTime]);
    //               }
    //               else{
    //                 noCutVideos.push(word.startTime)
    //               }
    //           })
    //         }
    //       })
  
    //       me.syncVideoCuts(noCutVideos, cutVideos);
  
    //       // // for all cut videos check if exist if not then add
    //       // noCutVideos.forEach((startTime)=>{
    //       //   var exist = me.videoCuts.find(function(cut){return cut[0] === startTime});
  
    //       //   if(exist){
    //       //     me.removeVideoCuts(startTime);
    //       //   }
  
    //       // })
  
    //       // cutVideos.forEach((range)=>{
    //       //   var exist = me.videoCuts.find(function(cut){return cut[0] === range[0]});
  
    //       //   if(!exist){
    //       //      me.setVideoCuts(range);
    //       //   //  me.removeVideoCuts(startTime);
    //       //   }
  
    //       // })
  
    //       me.phrases = clonePhrases.map(function(p){
    //         if(hash[p.id]){
    //           const repacePhrase = hash[p.id];
    //           delete hash[p.id];
    //           return repacePhrase;
    //         }
    //         else{
    //           return p;
    //         }
    //       })
  
    //       Object.keys(hash).forEach(key => {
    //         me.phrases.push(hash[key]);
    //       });
  
    //       me.phrases = me.phrases.filter(function(f){
    //         return !!f.words;
    //       })
  
    //       me.phrases = transcriptHelper.getSortedPhrases(me.phrases);
    //       me.refreshVideoCut();
    //       me.savePhrase(pre, activePhrase,activePhrase ? activePhrase.transcript.length  : 0, false);
    //   },
    //   redo(event){
    //     const me = this;
    //     const pre = me.getNextInFutureStack();
    //       if(!pre) return;
  
    //       me.eventObj = event;
    //       const activePhrase = pre[pre.length-1];
    //       const clonePhrases = JSON.parse(JSON.stringify(me.phrases));
    //       const hash = {};
  
    //       const cutVideos = [];
    //       const noCutVideos = [];
    //       pre.forEach(function(prePhrase){
    //         hash[prePhrase.id] = prePhrase;
    //         if(prePhrase.words){
    //           prePhrase.words.forEach(function(word){
    //         // get all the starttime of cutvideos
    //               if(word.isVideoCut){
    //                 cutVideos.push([word.startTime,word.endTime]);
    //               }
    //               else{
    //                 noCutVideos.push(word.startTime)
    //               }
    //           })
    //         }
    //       })
  
          
    //       me.syncVideoCuts(noCutVideos, cutVideos);
  
    //       me.phrases = clonePhrases.map(function(p){
    //         if(hash[p.id]){
    //           const repacePhrase = hash[p.id];
    //           //me.updatePaginatedPhrase(p.id, repacePhrase);
    //           delete hash[p.id];
    //           return repacePhrase;
    //         }
    //         else{
    //           return p;
    //         }
    //       })
  
    //       Object.keys(hash).forEach(key => {
    //         me.phrases.push(hash[key]);
    //       });
  
    //       me.phrases = me.phrases.filter(function(f){
    //         return !!f.words;
    //       })
  
    //       me.phrases = transcriptHelper.getSortedPhrases(me.phrases);
    //       me.refreshVideoCut();
    //       me.savePhrase(pre, activePhrase,activePhrase ? activePhrase.transcript.length  : 0, false);
    //   },
    //   checkEmptyPhrase(e){
    //     const me = this;
    //     document.querySelectorAll('.phrase-content-container').forEach(function(doc){
  
    //       if(doc && doc.contentEditable !== 'false') {
    //         const phraseContentDom = doc.querySelector('.phrase-content');
    //         let errMessage = ''
  
    //         if(!phraseContentDom){
    //           errMessage = 'missing phrase-content=='+ doc.outerHTML+'-----------------------------'+(e && e.detail);
    //           me.onTest({errorMessage:errMessage,id:doc.getAttribute('data-container-position'), forceRefresh:true});
    //         }
    //       }
  
          
    //       // else if(!phraseContentDom.innerHTML){
    //       //   errMessage = 'missing phrase-content  inner content=='+ doc.outerHTML+'-----------------------------'+(e && e.detail);
    //       //   me.onTest({errorMessage:errMessage,id:doc.getAttribute('data-container-position'), forceRefresh:true});
    //       // }
    //     })
    //   },
    //   refreshVideoCut(){
    //     const me = this;
    //     const selectionInfo = transcriptHelper.getSelectionInfo(me.phrases);
    //     if(me.isInvalidSelectionInfo(selectionInfo)) return;
    //   //  if(!selectionInfo || selectionInfo.phraseStartIndex < 0 || selectionInfo.phraseEndIndex < 0) return;
  
    //     for(var i = selectionInfo.phraseStartIndex ; i <= selectionInfo.phraseEndIndex ; i++){
    //       let phraseId = me.phrases[i].id
    //       let wordStart = 0;
    //       let wordEnd = me.phrases[i].words.length-1;
          
    //       if(selectionInfo.phraseStartIndex === selectionInfo.phraseEndIndex){
    //           wordStart = transcriptHelper.getWordIndexByIndexFromTo(
    //             me.phrases[i].words,
    //             selectionInfo.charEndIndex
    //           );
  
    //           wordEnd = wordStart;
    //       }
    //       else{
    //         if(i === selectionInfo.phraseStartIndex){
    //           wordStart = null
    //         }
    //         if(i === selectionInfo.phraseEndIndex){
    //           wordEnd = null;
    //         }
    //       }
  
    //     //   if( wordStart !== null && wordEnd !== null && me.phrases[i].words[wordStart] && me.phrases[i].words[wordEnd] && me.phrases[i].words[wordStart].id === me.phrases[i].words[wordEnd].id && (me.phrases[i].words[wordStart].isVideoCut || me.phrases[i].words[wordEnd].isVideoCut)){
    //     //     me.$refs.replacePopup.onVideoToggle(phraseId, wordStart , wordEnd, true, true);
    //     //   }
    //     }
    //   },
      isSpeakerMenu(event){
        let menu = null;
  
        if(event && event.target && event.target.closest){
          menu = event.target.closest('.dropdown-menu');
        }
  
        return !!menu;
      },
    //   getSanitizedCopyCutData(){
    //     const cutSelection = document.getSelection();
    //     const me = this;
  
    //     let selectionStrings = cutSelection.toString().split(/[\n\u0085\u2028\u2029]|\r\n?/);
    //     let selectionString = '';
    //     let speakerDefault = me.$lang.common.speakers.split(' ')[0];
  
    //     if(selectionStrings.length >= 3){
    //       let remove = false;
    //   for(var endIndex = selectionStrings.length -1; endIndex >=0 ; endIndex--){
    //     if(selectionStrings[endIndex].trim() === '#' && selectionStrings[endIndex-1]&& !isNaN(selectionStrings[endIndex-1]) ){
    //       selectionStrings.splice(endIndex, 1);
    //       remove = true;
    //     }
    //     else if(remove){
    //       selectionStrings.splice(endIndex, 1);
    //       remove = false;
    //     }
    //     else if(selectionStrings[endIndex].trim() === ''){
    //       selectionStrings.splice(endIndex, 1);
    //     }
    //     else if(selectionStrings[endIndex].trim() === ('('+speakerDefault+')')){
    //       selectionStrings.splice(endIndex, 1);
    //     }
    //     else if(/\d{2}:\d{2}\.\d{2}\d{2}:\d{2}\.\d{2}/.test(selectionStrings[endIndex].trim())){
    //       selectionStrings.splice(endIndex, 1);
    //     }
    //     }
  
    //     selectionStrings.forEach(function(selectedStr){
    //       selectionString += selectedStr;
    //     })
    //     }
    //     else if(selectionStrings.length === 1){
    //       selectionString = selectionStrings[0];
    //     }
  
    //     return selectionString;
    //   }
    },
    mounted() {
      const me = this;
  
    //   me.debouncePhraseCheck = debounce(function() {
    //       me.checkEmptyPhrase({detail:'debounce phrase check'});
    //   }, 300);
  
    //   me.debounceSetCaret = debounce(function() {
        
    //     //console.log('set caret:'+me.isIMEInput)
      
    //       if(me.isIMEInput){
    //         // me.isIMEInput = false;
    //         window.getSelection().removeAllRanges();
    //         me.$refs.editingpanel.blur();
    //       }
  
    //      me.$forceNextTick(() => {
    //       if(me.isIMEInput){
    //         me.isIMEInput = false;
    //         me.debounceOnInputChange();
    //       }
    //     //    me.setCaret();
    //       })
    //   }, 10, true);
  
    //   me.debounceOnInputChange = debounce(function(event) {
    //         // if(me.isIMEInput){
    //         //   me.isIMEInput = false;
    //         //   window.getSelection().removeAllRanges();
    //         //   me.$refs.editingpanel.blur();
    //         // }
    //         me.onInputChange(event);
    //     }, 10); //1000 * 60 * 15
  
      me.$refs.editingpanel.addEventListener('click', function (event) {
        if(me.isSpeakerMenu(event)) return;
        let selectionInfo = transcriptHelper.getSelectionInfo(me.phrases)
        if(!selectionInfo) return;
        me.caretPosition = selectionInfo.charStartIndex
        // fire click event to EditTranscript (pause media if settings allow)
        me.$emit('click')
      })
  
      if(me.readOnly === true){
        return;
      }
  
    //   me.$refs.editingpanel.addEventListener('dblclick', function (event) {
    //     if(me.isSpeakerMenu(event)) return;
    //     let selectionInfo = transcriptHelper.getSelectionInfo(me.phrases)
       
    //     if(me.isInvalidSelectionInfo(selectionInfo)) return;
    //     me.$emit('dblclick', selectionInfo)
    //   })
  
    //   me.$refs.editingpanel.addEventListener('compositionstart', function (event) {
    //     if(me.isSpeakerMenu(event)) return;
    //     // we want this here so that when it starts and end by scrolling it still gets saved
    //       me.selectionInfo = transcriptHelper.getSelectionInfo(me.phrases)
    //       me.isIMEInput = true // When input menu is visible (for foreign input)
    //    //   me.customKeypress(event);
    //   })
  
    //   me.$refs.editingpanel.addEventListener('compositionend', function (event) {
    //     if(me.isSpeakerMenu(event)) return;
    //     me.isIMEInput = false // When input menu is not visible (for foreign input)
  
    //     // this is on normal exit it should include the length of the new data for the caret
    //     if(me.selectionInfo){
    //       me.selectionInfo.charOffSet = (event.data?event.data.length : 0 )
    //     }
  
    //     //  console.log('compositionend')
    // //  me.onInputChange(event)
    //   //  me.$forceNextTick(function(){
    //     //  me.debounceOnInputChange(event);
    //    // })
    //   })
  
      me.$refs.editingpanel.addEventListener('mousedown', function (event) {
        if(me.isSpeakerMenu(event)) return;
        me.isIMEInput = false
        // this is mouse down to make sure it is triggered
        //me.debounceOnInputChange(event);
      })
  
      me.$refs.editingpanel.addEventListener('mouseup', function (event) {
        if(me.isSpeakerMenu(event)) return;
      //  me.showReplacePopup(event);
  
        const selectionInfo = transcriptHelper.getSelectionInfo(me.phrases);
        let tempFocusId = null;
  
        if(selectionInfo && selectionInfo.charStartIndex > -1 && selectionInfo.phraseStartIndex > -1){
          tempFocusId = me.phrases[selectionInfo.phraseStartIndex].id;
          event.stopPropagation();
        }
  
        me.setFocusId(tempFocusId);
      })
  
      // prevent text selection drop
      me.$refs.editingpanel.addEventListener('drop', function (event) {
        if(me.isSpeakerMenu(event)) return;
         event.preventDefault();
         event.stopPropagation(); 
      })
  
    //   me.$refs.editingpanel.addEventListener('keydown', function (event) {
    //     if(event.target.type === 'textarea') return;
  
    //     textHelper.disableFunctionKeys(event);
  
    //     // is time duration starting time update 
    //     if(event.altKey && textHelper.isArrowKeyPressed(event)){
    //       event.preventDefault();
    //       event.stopPropagation(); 
    //       const keyCode = event.which || event.keyCode || 0;
    //       const selectionInfo = transcriptHelper.getSelectionInfo(me.phrases);
  
    //       if(!selectionInfo || selectionInfo.phraseStartIndex < 0 || selectionInfo.phraseEndIndex < 0) return;
          
    //       const timePhrase = me.phrases[selectionInfo.phraseStartIndex];
    //       const bounds = transcriptHelper.getUpperAndLowerBound(me.duration, selectionInfo.phraseStartIndex, me.phrases);
    //       let lowerBound = bounds.lowerBound;
    //       let upperBound = bounds.upperBound;
  
          
    //       let delta = 0.5;
  
    //       if(keyCode === 37 && (timePhrase.startTime - delta > lowerBound || timePhrase.startTime - 0.01 !== lowerBound )){
    //         delta = Math.min(timePhrase.startTime - lowerBound - 0.01 , 0.5);
    //         me.dragTimeUpdate({phraseId: timePhrase.id, deltaSeconds: -delta})
    //       }
    //       else if(keyCode === 38 && (timePhrase.endTime + delta < upperBound || timePhrase.endTime + 0.01 !== upperBound)){
    //         me.resizeTimeUpdate({phraseId: timePhrase.id, isLeft: false, newSeconds: Math.min(timePhrase.endTime + delta, upperBound - 0.01)})
    //       }
    //       else if(keyCode === 39 && (timePhrase.endTime + delta < upperBound || timePhrase.endTime + 0.01 !== upperBound)){
    //         delta = Math.min(upperBound - timePhrase.endTime - 0.01 , 0.5);
    //         me.dragTimeUpdate({phraseId: timePhrase.id, deltaSeconds: delta})
    //       }
    //       else if(keyCode === 40 && timePhrase.endTime - delta > timePhrase.startTime){
    //         me.resizeTimeUpdate({phraseId: timePhrase.id, isLeft: false, newSeconds: timePhrase.endTime - delta})
    //       }
    //       else{
    //         return;
    //       }
  
    //       me.savePhrase([timePhrase], timePhrase, selectionInfo.charStartIndex,false);
    //     }
  
    //     else if(me.isSpeakerMenu(event)) {return;}
  
    //     else if(textHelper.isTextSearch(event)){
    //       event.preventDefault();
    //       return;
    //     }
  
    //     else if(textHelper.isToggleNote(event)){
    //       event.preventDefault();
    //       return;
    //     }
  
    //     else if(textHelper.isCopyCutPaste(event)){
    //       return true;
    //     }
  
    //     else if(textHelper.isToggleMediaFramePressed(event)){
    //       event.preventDefault();
    //     }
    //     else if(textHelper.isMediaControlPressed(event)){
    //       event.preventDefault();
    //       me.clearCaretPosition();
    //     }
    //     else if(textHelper.isArrowKeyPressed(event)){
    //       me.$forceNextTick(() => {
    //           me.updateCaretPosition();
    //       })
    //       return true;
    //     }
    //     else if(transcriptHelper.isRedoPressed(event)){
    //       event.preventDefault();
    //       me.redo(event);
    //       return false;
    //     }
    //     else if(transcriptHelper.isUndoPressed(event)){
    //       event.preventDefault();
    //       me.undo(event);
    //       return false;
    //     }
    //     else if(!me.isIMEInput && !textHelper.isCopyCutPaste(event) && !textHelper.isUnicodeSpecialChar(event) && !textHelper.isModifierKey(event)){
  
    //       if(textHelper.isDeletionKey(event) || textHelper.isEnterKey(event)){
    //         me.refreshVideoCut();
    //       }
    //       me.customKeypress(event);
    //     }
    //   })
  
    //   me.$refs.editingpanel.addEventListener('keyup', function (event) {
    //     if(me.isSpeakerMenu(event)) return;
    //     const keyCode = event.which || event.keyCode || 0;
    //     if(event.shiftKey && (keyCode === 37 || keyCode === 39)){
    //       event.preventDefault();
    //     //  me.showReplacePopup(event);
    //     }
    //   })
  
  
    //   me.$refs.editingpanel.addEventListener('copy', (event) => {
    //     event.preventDefault(); 
    //     event.clipboardData.setData('text/plain', me.getSanitizedCopyCutData());
    //   });
  
    //   me.$refs.editingpanel.addEventListener('cut', (event) => {
    //     event.clipboardData.setData('text/plain', me.getSanitizedCopyCutData());
    //     me.customKeypress(event) // cut
    //   });
  
    //   me.$refs.editingpanel.addEventListener('paste', function (event) {
  
    //     me.customKeypress(event) // paste
    //   })
  
      // fix the resize observer dom to not be able to be edit by accident
      if(document.querySelector('.resize-observer')){
        document.querySelector('.resize-observer').setAttribute('contenteditable',false)
      }
    }
  };
  </script>
  
  
  <style>
  #vue-recycle-scroller{
    display:flex;
    padding-top:30px;
  }
  .windowMode{
    height:calc(100vh - 300px);
  
     /* height:auto;  */
  }
  .windowContainer{
        position: fixed!important;
      width: calc(50% - 25px);
  }
  .vue-recycle-scroller__item-wrapper{
  overflow: visible;
  }
  .editing-container {
    /* margin: 1px 5px; */
    padding: 0px 0px;
    padding-top:15px;
    border-left: 2px solid transparent;
    border-right: 2px solid transparent;
    border-left: transparent 5px solid;
    border-right: transparent 5px solid;
    box-shadow: 0 1px 4px rgba(1, 1, 1, 0.15);
    -webkit-transition: all 100ms ease-in-out;
    -moz-transition: all 100ms ease-in-out;
    -o-transition: all 100ms ease-in-out;
    transition: all 100ms ease-in-out;
    user-select: none;
    background:white;
    border-radius: 10px;
  }
  .editing-container .phrase-content > span {
    -webkit-transition: color 0.2s ease;
    -moz-transition: color 0.2s ease;
    -o-transition: color 0.2s ease;
    transition: color 0.2s ease;
    color: #06150e;
  }
  
  .editing-container.no-space .phrase-content > span {
    font-size: 22px;
  }
  .editing-container.no-space .phrase-content:focus{
    font-size: 22px;
  }
  
  .nonselectable {
    user-select: none!important;
    -webkit-user-select: none!important;
    -moz-user-select: none!important;
    -ms-user-select: none!important;
  }
  
  .caption-card-enter-active,
  .caption-card-leave-active {
    transition: all 0.5s;
  }
  .caption-card-enter/* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(15px);
  }
  
  .caption-card-leave-to {
    transform: translateX(-2000px);
  }
  
  .v-btn.fullscreen {
    position: absolute;
    top: 0;
    right: 10px;
    user-select: none;
    z-index:30;
  }
  
  .v-btn.fullscreen_exit {
    position: absolute;
    top: 0;
    right: 10px;
    user-select: none;
    z-index:30;
  }
  .v-btn .v-icon {
    user-select: none;
  }
  
  /* div[data-index="-1"] .phrase-content-container{
    user-select: none!important;
    -webkit-user-select: none!important;
    -moz-user-select: none!important;
    -ms-user-select: none!important;
  }
  
  .phrase-highlight .phrase-content-container{
    background:rgba(32, 247, 196, 0.05);
    border-radius: 5px;
  } 
  */
  @media (max-width: 992px) {
    .editing-container{
      -webkit-user-select: text;
      user-select: text;
    }
  }
  
  @media only screen and (max-device-width: 600px) {
    .editing-container.no-space .phrase-content > span {
      font-size: 16px;
    }
  }
  </style>